import { createSelector } from 'reselect'
import { initialState } from './reducer'
import { makeSelectIsLoading } from '../loading/selectors'
import { LOGIN_REQUEST } from './actionTypes'

const selectAuth = (state: any) => state.auth || initialState

const makeSelectIsLoginPending = () => makeSelectIsLoading(LOGIN_REQUEST)

const makeSelectUser = () => createSelector(selectAuth, (substate) => substate.user)

const getLoginErrorSelector = () => createSelector(selectAuth, (substate) => substate.loginError)

const sidebarStateSelector = () => createSelector(selectAuth, (substate) => substate.sidebarState)

const initSelector = () => createSelector(selectAuth, (substate) => substate.initCompleted)
const makeSelectToken = () => createSelector(selectAuth, (substate) => substate.token)

export {
  makeSelectIsLoginPending,
  makeSelectUser,
  initSelector,
  getLoginErrorSelector,
  sidebarStateSelector,
  makeSelectToken,
}
